<mat-card-content>
  <div id="containerProyeccion">
    <div class="center-container">
      <small class="subitutlo-simpli">*Proyección de las ganancias futuras esperadas, manteniendo la inversión hasta
        el vencimiento, sujeto a variaciones en la TPM.</small>
    </div>
  </div>
</mat-card-content>